export enum EntityType {
    individual = 'A11AE016-8E6E-4341-A4E7-D1848967897B',
    note = '38DFD598-158A-47E5-AB56-9D25625C13FC',
    address = '43215A69-9A54-4CFA-A5F5-B4C0AD0A9D9A',
    idInfo = 'F5BF2831-910B-414E-ACFC-E9A4141B96C9',
    phone = 'F230DBDD-DA1F-4174-BB7B-F67FA657B888',
    attachment = '7FD70A51-9A67-45DF-91C4-5A0DC470750D',

    // lookup =  'D88DB033-D427-4E9F-96F6-39A468CAA5D6',
    // checkMember = '23A90C5E-7910-400A-AC9D-5555696CD4B6',
    // checkDuplicate = '53F13DE6-D9F1-47F1-87FD-6D1D857DA52D',

    lookup  = 'd88db033-d427-4e9f-96f6-39a468caa5d6',
    checkMember = '23a90c5e-7910-400a-ac9d-5555696cd4b6',
    checkDuplicate = '53f13de6-d9f1-47f1-87fd-6d1d857da52d',
}
